/**
 * Centralized registry of all backend API endpoints.
 * Matches the structure of backend/config.py.
 */

export const API_BASE_URL = "https://dev-api.xeroalpha.com/api";
export const ENDPOINTS = {
  AUTH: {
    LOGIN: "/login",
    REFRESH: "/refresh",
  },
  LEADS: {
    ROOT: "/leads",
    BULK_IMPORT: "/leads/bulk-import",
    STAGE: (id: string) => `/leads/${id}/stage`,
    HISTORY: (id: string) => `/leads/${id}/history`,
  },
  SUPERADMIN: {
    CLIENTS: "/superadmin/clients",
    CUSTOMERS: "/superadmin/customers",
    ACCESS_CONTROL: "/superadmin/access-control",
    GROUPS: "/superadmin/groups",
    MODULES: "/superadmin/modules",
  },
  AUTODIALER: {
    CAMPAIGNS: "/auto-dialer/campaigns",
    CONTACTS: "/auto-dialer/contacts",
    DIAL: (id: string) => `/auto-dialer/dial/${id}`,
  },
  DASHBOARD: {
    STATS: "/dashboard/stats",
    ACTIVITY: "/dashboard/activity",
    SUMMARY: "/dashboard/campaign-summary",
  },
  SALARY: {
    COMPONENTS: "/salary/components",
    STRUCTURES: "/salary/structures",
    ASSIGNMENT: "/salary/assign",
    PAYROLL: "/salary/payroll-run",
  },
  BULK_COMMUNICATION: {
    CAMPAIGNS: "/bulk-communication/campaigns/",
    CREATE_FROM_DATA: "/bulk-communication/campaigns/send/",
    UPLOAD_CSV: (id: string) => `/bulk-communication/campaigns/${id}/upload-csv/`,
    UPLOAD_MEDIA: "/bulk-communication/campaigns/upload_media/",
    DISPATCH: (id: string) => `/bulk-communication/campaigns/${id}/trigger-dispatch/`,
    PAUSE: (id: string) => `/bulk-communication/campaigns/${id}/pause/`,
    DELETE: (id: string) => `/bulk-communication/campaigns/${id}/`,
    RELAUNCH: (id: string) => `/bulk-communication/campaigns/${id}/relaunch/`,
    REPORT: (id: string) => `/bulk-communication/campaigns/${id}/report/`,
  },
  HEALTH: "/health",
  ACADEMICS: {
    DEPARTMENTS: "/academics/departments/",
    COURSES: "/academics/courses/",
  },
  PUBLIC: {
    REGISTER: "/leads/public/register/",
  },
};
